import userStore from "@/store/modules/userStore";
import { useDisplayHelpers } from "@/components/mixins/DisplayHelpers";

export interface Address {
  addressBusinessName?: string;
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  addressLine4: string;
  addressLine5: string;
  addressPostcode: string;
  addressLine6: string;
}

export enum AddressParts {
  AddressBusinessName = "addressBusinessName",
  AddressLine1 = "addressLine1",
  AddressLine2 = "addressLine2",
  AddressLine3 = "addressLine3",
  AddressLine4 = "addressLine4",
  AddressLine5 = "addressLine5",
  AddressPostcode = "addressPostcode",
  AddressLine6 = "addressLine6",
}

export function getAddressPartDisplayOrder(): AddressParts[] {
  const countryCode =
    userStore.state.tenant?.locationConfiguration.locationCountryCode ?? "GB";

  if (countryCode === "DE") {
    return [
      AddressParts.AddressBusinessName,
      AddressParts.AddressLine1,
      AddressParts.AddressLine2,
      AddressParts.AddressLine3,
      AddressParts.AddressPostcode,
      AddressParts.AddressLine4,
      AddressParts.AddressLine5,
      AddressParts.AddressLine6,
    ];
  }

  return Object.values(AddressParts);
}

export function formatAddressForDisplay(
  address: Address,
  defaultEmptyValue = "-"
) {
  const { displayString } = useDisplayHelpers({ defaultValue: "" });

  const formattedAddress = displayString(
    getAddressPartDisplayOrder()
      .map((part) => {
        return address[part];
      })
      .filter((v) => !!v)
      .join(", ")
  );

  return formattedAddress === "-" ? defaultEmptyValue : formattedAddress;
}

export function cloneAddress(toClone: Address): Address {
  return {
    addressBusinessName: toClone.addressBusinessName,
    addressLine1: toClone.addressLine1,
    addressLine2: toClone.addressLine2,
    addressLine3: toClone.addressLine3,
    addressLine4: toClone.addressLine4,
    addressLine5: toClone.addressLine5,
    addressPostcode: toClone.addressPostcode,
    addressLine6: toClone.addressLine6,
  };
}
